module.exports = __webpack_public_path__ + "media/img/specialize/item13-1ed9a8f95bc0a87f4632b7757f76b486.svg";